import { render, staticRenderFns } from "./serviceFeatures.vue?vue&type=template&id=619423f7&scoped=true&"
import script from "./serviceFeatures.vue?vue&type=script&lang=js&"
export * from "./serviceFeatures.vue?vue&type=script&lang=js&"
import style0 from "./serviceFeatures.vue?vue&type=style&index=0&id=619423f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619423f7",
  null
  
)

export default component.exports